import AddFromTag from '../components/addFromTag';
import  info  from '../components/product/content/info'; 
import Swiper, { Navigation, Pagination, Grid, Autoplay, Lazy } from 'swiper';
Swiper.use([Navigation, Pagination, Grid, Autoplay, Lazy]);
 
import { pagination } from '../components/products/content/pagination.js';

const home = {
  setBannerRotative: () => {
    const bannerRotative = document.querySelectorAll('[data-banner-rotative]');

    bannerRotative.forEach((section) => {
      const carousel = section.querySelector('.swiper');
      const pagination = section.querySelector('.swiper-pagination');
      const next = section.querySelector('.swiper-button-next');
      const prev = section.querySelector('.swiper-button-prev');

      const rotative = new Swiper(carousel, {
        modules: [Navigation, Pagination, Lazy],
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow: true,
        autoHeight: true,
        preloadImages: false,
        lazy: true,
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        autoplay: {
          delay: 4000,
        }, 
        pagination: {
          el: pagination,
          type: 'bullets',
          clickable: true,
        },
      });

      rotative.autoplay.stop();
      const setAutoPlay = () => {
        window.removeEventListener('scroll', setAutoPlay);
        window.removeEventListener('mousemove', setAutoPlay);
        rotative.autoplay.start();
      }
      window.addEventListener('scroll', setAutoPlay);
      window.addEventListener('mousemove', setAutoPlay);
    });
  },

  // =========== Carrosel grid home =========== //
  setProductsCarouselGrid: function () {
    const productsCarousel = document.querySelectorAll('[data-products-carousel-grid]');

    productsCarousel.forEach((section) => {
      const carousel = section.querySelector('.swiper');
      const pagination = section.querySelector('.swiper-pagination');
      const next = section.querySelector('.swiper-button-next');
      const prev = section.querySelector('.swiper-button-prev');

      new Swiper(carousel, {
        modules: [Navigation, Pagination, Grid],
        slidesPerView: 3,
        spaceBetween: 16,
        watchOverflow: true,
        preloadImages: false,
        lazy: true,
        slidesPerView: '4',
        spaceBetween: '20',
        grid: {
          rows: 2,
          fill: 'row',
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 24,
          },        
        },
        mousewheel: {
          forceToAxis: true,
        },
        pagination: {
          el: pagination,
          type: 'bullets',
          clickable: true,
        },
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
      });
    });
  },
  /*
  setProductsCarouselGrid: function () {
     
    const carrosselSections = document.querySelectorAll('[data-products-carousel-grid]');
    carrosselSections.forEach((section) => {
      const carousel = section.querySelector('.swiper');
      const next = section.querySelector('.swiper-button-next');
      const prev = section.querySelector('.swiper-button-prev');
      const pagination = section.querySelector('.pagination');
  
      const newCarrossel = new Swiper(carousel, {
        watchOverflow: true,
        pagination: {
          el: pagination,
          type: 'bullets',
          clickable: true,
        },
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        slidesPerView: parseFloat(section.dataset.carrosselSlidesperviewMobile),
        spaceBetween: parseFloat(section.dataset.carrosselSpacebetweenMobile),
        modules: [Grid],
        grid: {
          rows: 3,
          fill: 'row',
        },
        breakpoints: {
          640: {
            slidesPerView: parseFloat(section.dataset.carrosselSlidesperview),
            spaceBetween: parseFloat(section.dataset.carrosselSpacebetween),
          },
        },
      });
    });
  },*/

  setProductsCarousel: function () {
    const productsCarousel = document.querySelectorAll('[data-products-carousel]');

    productsCarousel.forEach((section) => {
      const carousel = section.querySelector('.swiper');
      const pagination = section.querySelector('.swiper-pagination');
      const next = section.querySelector('.swiper-button-next');
      const prev = section.querySelector('.swiper-button-prev');

      new Swiper(carousel, {
        modules: [Navigation, Pagination, Grid],
        slidesPerView: 3,
        spaceBetween: 16,
        watchOverflow: true,
        preloadImages: false,
        lazy: true,
        loop: true,

        breakpoints: {
          0: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 24,
          },        
        },
        mousewheel: {
          forceToAxis: true,
        },
        pagination: {
          el: pagination,
          type: 'bullets',
          clickable: true,
        },
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
      });
    });
  },
  setCategoryIcons: () => {
    let slider = document.querySelector("[data-category-icons]");
    if (slider) {
      let init = new Swiper(slider, {
        slidesPerView: 5,
        //spaceBetween: 30,
        watchOverflow: true,
        passiveListeners: true,
        autoplay: {
          enabled: window.innerWidth < 768 ? true : false,
          delay: 4000,
        },
        loop: window.innerWidth < 768 ? true : false,
        speed: 1100,
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          1024: {
            slidesPerView: 5,
            //spaceBetween: 30
          },
        }
      });
    }
  },
  setSliderQuotes: function() {
    const quotations = document.querySelector('[data-slider-quotes]');

    const sliderQuotes = new Swiper(quotations, {
      modules: [Pagination],
      loop: false,
      slidesPerView: 1,
      watchOverflow: true,
      passiveListeners: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
    })
  },
  setCategoryIconsBrand: () => {
    let slider = document.querySelector("[data-category-icons-brand]");
    if (slider) {
      let init = new Swiper(slider, {
        slidesPerView: 4,
        spaceBetween: 10,
        watchOverflow: true,
        loop: true,
        speed: 2000,
        keyboardControl: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        breakpoints: {
          100: {
            slidesPerView: 1,
            spaceBetween: 40
          },
          720: {
            slidesPerView: window.sizeBannersBrand >= 8 ? 8 : window.sizeBannersBrand,
            spaceBetween: window.sizeBannersBrand >= 8 ? 30 : (8 - window.sizeBannersBrand) * 40 ,
          },
        },
      });
    }
  },
  init: function () {
    this.setBannerRotative();
    this.setProductsCarousel();
    this.setCategoryIcons();
    this.setSliderQuotes();
    this.setCategoryIconsBrand();
    this.setProductsCarouselGrid();

    const selector = $('[data-action="add-cart"]');
    selector.addClass('pointer-none');
    window.addEventListener('load', () =>{
      selector.removeClass('pointer-none')      
      AddFromTag.init();
      info.init();

      //Controle de altura da descrição do product-block
      var maxHeight = 0;
      $('[data-product-block-description]').each(function(){
        var thisH = $(this).height();
        if (thisH > maxHeight) { maxHeight = thisH; }
      });

      $('[data-product-block-description]').height(maxHeight);
    }); 

    pagination.init();
  },
};

export default home;
